/**
 * @module constants/MusicActions
 */

/**
 * The exposed, namespaced Music related actions.
 */
export const MusicActions = Object.freeze({
  GET_ARTIST: 'GET_ARTIST',
  GET_ARTIST_FAIL: 'GET_ARTIST_FAIL',
  GET_ALBUM: 'GET_ALBUM',
  GET_ALBUM_FAIL: 'GET_ALBUM_FAIL',
  GET_TRACK: 'GET_TRACK',
  GET_TRACK_FAIL: 'GET_TRACK_FAIL',
  GET_LYRICS: 'GET_LYRICS',
  GET_LYRICS_FAIL: 'GET_LYRICS_FAIL',
});

export default MusicActions;
